<template>
  <div />
</template>

<script setup lang="ts">
import type { VideoDrop } from '@/types/shopify/video'
export interface Props {
  name: string
  target: string
  desktop: VideoDrop
  mobile: VideoDrop
}
const props = defineProps<Props>()
document.addEventListener('ab:video-swap', (e: Event) => {
  if ((<CustomEvent>e).detail === props.name) {
    const event = new CustomEvent(`ab:video-swap:${props.target}`, { detail: JSON.stringify(props) })
    document.dispatchEvent(event)
  }
})
// Usage:
//   Make sure `name` is unique, and target matches the ID of the video section you wish to swap.
//   Event detail will be the `name` property
// var event = new CustomEvent('ab:video-swap', { detail: 'abc123' })
// document.dispatchEvent(event)
</script>
